import axios, { AxiosResponse } from 'axios';

const url = `/services/isnaportal/open-api/taxpayer-data/search-in-knp`;
export const urlPrint = url;
// clientRecaptchaResponse=${token}
export const getTaxPayerInfo = (
    request: any,
    secretKey?: any,
    token?: any
): Promise<AxiosResponse> => {
    let query = '?';
    if (secretKey) query += `token=${secretKey}`;
    return axios.post(`${url}` + query, request);
};
